import electricLogo from '@/assets/electric_logo_red.svg';
import { NAV_HEIGHT } from '@/components/Nav/sizes';
import {
  ColorsV2,
  EmptyState,
  Flex,
  getToken,
  OneColumnLayout,
  Pane,
} from '@electricjs/arc';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledTopNav = styled(Pane)`
  z-index: 2;
  height: ${NAV_HEIGHT};
  min-height: ${NAV_HEIGHT};
  padding: 0 2.5rem;
  border-radius: unset;
  flex-wrap: nowrap;
  align-items: center;

  justify-content: flex-start;

  background: ${getToken(ColorsV2.BACKGROUND)};
  border-bottom: solid 1px ${getToken(ColorsV2.GRAY_LIGHT)};

  img {
    height: 3rem;
  }
`;

const MaintenancePage = () => {
  const { t } = useTranslation('pages');

  return (
    <>
      <nav>
        <StyledTopNav>
          <img alt="Electric" height="42" src={electricLogo} />
        </StyledTopNav>
      </nav>
      <OneColumnLayout>
        <Flex
          height="calc(100vh - 12.5rem)"
          justifyContent="center"
          alignItems="center">
          <EmptyState
            title={t('maintenance.title')}
            subTitle={t('maintenance.subtitle')}
            icon="wrench"
          />
        </Flex>
      </OneColumnLayout>
    </>
  );
};

export default MaintenancePage;
